// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scan {
  overflow: hidden;
  border: 2px solid #ccc;
  padding: 1rem;
  margin-bottom: 1rem;
  box-shadow: 3px 3px 15px #000;
}

.scanningStrip {
  width: 100%;
  height: 5px;
  background: #aa1e1e;
  position: relative;
  animation: mymove 3s infinite;
}

.image-div {
  width: 100%;
  max-height: 255px;
  border: 1px solid #dee2e6;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.4;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/popups/upload-animation-pop-up/upload-animation-pop-up.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AACF;;AACA;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;AAEF;;AACA;EAEI,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AACJ","sourcesContent":[".scan{\n  overflow: hidden;\n  border:2px solid #ccc;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  box-shadow: 3px 3px 15px #000;\n}\n.scanningStrip{\n  width: 100%;\n  height: 5px;\n  background: #aa1e1e;\n  position: relative;\n  animation: mymove 3s infinite;\n}\n\n.image-div\n{\n    width:100%;\n    max-height:255px;\n    border:1px solid #dee2e6;\n    text-align:center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0.4;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
